// NK Twilight — Interactions Layer
// Scroll-Reveals + Day/Night-Slider + subtle Motion
(function () {
  'use strict';

  // ---- Scroll-Reveals via IntersectionObserver -----------------------
  var reveals = document.querySelectorAll('[data-nk-reveal]');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('nk-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('nk-revealed'); });
  }

  // ---- Day / Night Toggle Slider --------------------------------------
  function initDayNight(root) {
    var track  = root.querySelector('.nk-dn__track');
    var handle = root.querySelector('.nk-dn__handle');
    var night  = root.querySelector('.nk-dn__night');
    if (!track || !handle || !night) return;

    var dragging = false;
    var startX = 0;
    var startPct = 50;
    var currentPct = 50;

    function setPct(p) {
      p = Math.max(0, Math.min(100, p));
      currentPct = p;
      night.style.clipPath = 'inset(0 0 0 ' + p + '%)';
      handle.style.left = p + '%';
    }
    setPct(50);

    function clientX(e) {
      return (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
    }

    function onMove(e) {
      if (!dragging) return;
      var rect = track.getBoundingClientRect();
      var dx = clientX(e) - rect.left;
      setPct((dx / rect.width) * 100);
      e.preventDefault();
    }

    function onStart(e) {
      dragging = true;
      startX = clientX(e);
      startPct = currentPct;
      handle.classList.add('is-dragging');
      e.preventDefault();
    }

    function onEnd() {
      dragging = false;
      handle.classList.remove('is-dragging');
    }

    handle.addEventListener('mousedown', onStart);
    handle.addEventListener('touchstart', onStart, { passive: false });
    window.addEventListener('mousemove', onMove);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('mouseup', onEnd);
    window.addEventListener('touchend', onEnd);

    // Klick irgendwo auf den Track setzt den Slider dorthin
    track.addEventListener('click', function (e) {
      if (e.target === handle) return;
      var rect = track.getBoundingClientRect();
      setPct(((e.clientX - rect.left) / rect.width) * 100);
    });

    // Keyboard-Accessibility
    handle.setAttribute('tabindex', '0');
    handle.setAttribute('role', 'slider');
    handle.setAttribute('aria-label', 'Tag/Nacht Ansicht');
    handle.setAttribute('aria-valuemin', '0');
    handle.setAttribute('aria-valuemax', '100');
    handle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  setPct(currentPct - 5);
      if (e.key === 'ArrowRight') setPct(currentPct + 5);
      handle.setAttribute('aria-valuenow', Math.round(currentPct));
    });

    // Auto-Demo beim ersten In-View: sanfter Swipe nach rechts & zurück
    if ('IntersectionObserver' in window) {
      var demoObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          demoObs.disconnect();
          var t0 = performance.now();
          function animate(ts) {
            var t = (ts - t0) / 1400;
            if (t >= 1) { setPct(50); return; }
            var eased = t < 0.5
              ? (0.5 + Math.sin(t * Math.PI * 2) * 0.28)
              : (0.5 + Math.sin(t * Math.PI * 2) * 0.28);
            setPct(eased * 100);
            requestAnimationFrame(animate);
          }
          requestAnimationFrame(animate);
        });
      }, { threshold: 0.4 });
      demoObs.observe(root);
    }
  }

  document.querySelectorAll('[data-nk-day-night]').forEach(initDayNight);

  // ---- Sticky Buy-Box visibility on PDP --------------------------------
  var stickyBuy = document.querySelector('[data-nk-sticky-buy]');
  var mainFormMarker = document.querySelector('[data-nk-main-form]');
  var mainForm  = mainFormMarker ? mainFormMarker.closest('form') : null;
  if (stickyBuy && mainForm && 'IntersectionObserver' in window) {
    var buyObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        stickyBuy.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '-200px 0px 0px 0px' });
    buyObs.observe(mainForm);
  }

  // ---- Parallax on Hero stars (subtle) ---------------------------------
  var hero = document.querySelector('[data-nk-hero]');
  if (hero && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    var stars = hero.querySelectorAll('.nk-hero__star');
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 700) return;
      stars.forEach(function (s, i) {
        var depth = (i % 3 + 1) * 0.05;
        s.style.transform = 'translateY(' + (y * depth) + 'px)';
      });
    }, { passive: true });
  }

})();
